import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  createWebHashHistory,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "TeamPl Main",
    component: () => import("../views/layouts/TPmain_layout.vue"),
    children: [
      {
        path: "/",
        name: "TeamPl Main",
        component: () => import("../views/solution/TPSolutionMain.vue"),
      },
      {
        path: "/viewer",
        name: "tampl viewer",
        component: () =>
          import("../components/solution/main/TPSolutionViewer.vue"),
      },
      {
        path: "/changer",
        name: "tampl changer",
        component: () =>
          import("../components/solution/main/TPSolutionChanger.vue"),
      },
      {
        path: "/filter",
        name: "tampl personal info filter",
        component: () =>
          import("../components/solution/main/TPSolutionFilter.vue"),
      },
      {
        path: "/faq",
        name: "after service and faq",
        component: () =>
          import("../components/solution/main/TPAfterServiceFAQ.vue"),
      },
    ],
  },

  {
    path: "/developer",
    name: "apiMain",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/developer/TPApiMain.vue"),
    children: [
      {
        path: "/developer",
        name: "api sub main",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/developer/TPApiRules.vue"
          ),
      },
      {
        path: "/apisetting",
        name: "api setting",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/developer/TPApiSubMain.vue"
          ),
      },
      {
        path: "/apiDetail",
        name: "apiDetail",
        component: () => import("@/views/developer/TPApiDetail.vue"),
      },
    ],
  },
  {
    path: "/intro",
    name: "TeamPl Introduction",
    component: () => import("../views/layouts/Intro_Layout.vue"),
    children: [
      {
        path: "/intro",
        name: "Introduction Main",
        component: () => import("../views/introduction/Tal_main.vue"),
      },
      {
        path: "/privacy",
        name: "privacy",
        component: () => import("../views/introduction/Ctp_PrivacyPolicy.vue"),
      },
      {
        path: "/policies",
        name: "policies",
        component: () => import("../views/introduction/Ctp_agreeService.vue"),
      },
      {
        path: "/preparing",
        name: "preparing",
        component: () => import("../views/introduction/Ctp_preparing.vue"),
      },
    ],
  },
];


const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});


export default router;
